
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_PluGrid extends Serenity.EntityGrid<MbReport_01_Dt_PluRow, any> {
        protected getColumnsKey() { return MbReport_01_Dt_PluColumns.columnsKey; }
        protected getDialogType() { return MbReport_01_Dt_PluDialog; }
        protected getIdProperty() { return MbReport_01_Dt_PluRow.idProperty; }
        protected getInsertPermission() { return MbReport_01_Dt_PluRow.insertPermission; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_PluRow.localTextPrefix; }
        protected getService() { return MbReport_01_Dt_PluService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}